import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button, Form, FloatingLabel, Dropdown, DropdownButton, InputGroup, Alert, Spinner } from 'react-bootstrap';
import { useSpring, animated } from '@react-spring/web';
import icon_check from '../images/icon_check.png';

const apiKey = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_PATH;

const countryPhoneCodes = [
    { code: '+56', name: 'Chile' },
    { code: '+34', name: 'España' },
    { code: '+1', name: 'Estados Unidos' },
    { code: '+52', name: 'Mexico' },
    { code: '+54', name: 'Argentina' },
    { code: '+57', name: 'Colombia' },
    { code: '+58', name: 'Venezuela' },
    { code: '+506', name: 'Costa Rica' },
    { code: '+502', name: 'Guatemala' },
    { code: '+503', name: 'El Salvador' },
    { code: '+591', name: 'Guinea' },
    { code: '+593', name: 'Ecuador' },
    { code: '+595', name: 'Paraguay' },
    { code: '+51', name: 'Peru' },
    { code: '+55', name: 'Brasil' },
    { code: '+56', name: 'Chile' },
];

const Contacto = () => {
    const [Nombre, setNombre] = React.useState('');
    const [Correo, setCorreo] = React.useState('');
    const [Codigo, setCodigo] = React.useState('+1');
    const [Telefono, setTelefono] = React.useState('');
    const [Mensaje, setMensaje] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [gracias, setGracias] = React.useState(false);

    const animacion = useSpring({
        opacity: gracias ? 1 : 0,
        transform: gracias ? 'scale(1)' : 'scale(0.8)',
        config: { duration: 500 },
    });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        try {
            if(!Correo || !Nombre || !Mensaje) {
                setError('Los campos con * son obligatorios y deben ser completados');
                setLoading(false);
                return;
            }

            const custom_headers = new Headers();
            custom_headers.append('x-api-key', `${apiKey}`);
            custom_headers.append('Content-Type', 'application/json');
            
            const raw = JSON.stringify({
                "NOMBRE": Nombre,
                "TELEFONO": Codigo + Telefono,
                "CORREO": Correo,
                "MENSAJE": Mensaje
            });

            const requestOptions = {
                method: 'POST',
                headers: custom_headers,
                body: raw,
                redirect: 'follow'
            };
            
            const response = await fetch(`${apiUrl}/api/contactos`, requestOptions);
            const result = await response.json();

            if(result.error) {
                setError(result.error);
                return;
            }

            setGracias(true);
            setCorreo('');
            setNombre('');
            setTelefono('+1');
            setMensaje('');
            setTimeout(() => {
                setGracias(false);
            }, 3000);
            
        } catch (error) {
            setError(error.message);
        }
        setLoading(false);
    }

    return (
        <section id="contactus" className="section contacto vertical bg-primary">
            <Container>
                <Row className="contenido justify-content-center">
                    <Col lg={8} className="mb-3">
                        <h1 className="heading1 text-white">Contacto</h1>
                    </Col>
                </Row>
                <Row className="contenido justify-content-center">
                    <Col lg={8} className="text-end">
                    {(gracias) ? (
                            <animated.div style={animacion}>
                                <Row className="justify-content-center">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3 mt-3 text-center">
                                        <img src={icon_check} alt="icon check" className="img img-fluid" width={100} />
                                        <br/><br/>
                                        <h1 className="heading1 text-white">¡Gracias, su mensaje ha sido enviado!</h1>
                                    </Col>
                                </Row>
                            </animated.div>
                        ) : (
                        <Form className="form-newsletter">
                            <FloatingLabel
                                controlId="floatingNombre"
                                label="Nombre *"
                                className="mb-3"
                            >
                                <Form.Control type="text" placeholder="Nombre" value={Nombre} onChange={(e) => setNombre(e.target.value)} required />
                            </FloatingLabel>
                            <FloatingLabel
                                controlId="floatingEmail"
                                label="Email *"
                                className="mb-3"
                            >
                                <Form.Control type="email" placeholder="Email" value={Correo} onChange={(e) => setCorreo(e.target.value)} required />
                            </FloatingLabel>
                            <InputGroup className="mb-3">
                                <DropdownButton variant="secondary" title={Codigo} >
                                    {countryPhoneCodes.map((country, index) => (
                                        <Dropdown.Item
                                            key={index}
                                            eventKey={country.code}
                                            onClick={() => setCodigo(country.code)}
                                        >
                                            {country.name}
                                        </Dropdown.Item>
                                    ))}
                                </DropdownButton>  
                                <FloatingLabel
                                    controlId="floatingAsunto"
                                    label="Teléfono"
                                >
                                    <Form.Control type="text" placeholder="Teléfono" value={Telefono} onChange={(e) => setTelefono(e.target.value)} />
                                </FloatingLabel>
                            </InputGroup>
                            <FloatingLabel
                                controlId="floatingCuerpo"
                                label="Cuerpo *"
                                className="mb-3"
                            >
                                <Form.Control as="textarea" placeholder="Mensaje" style={{ height: '100px' }} value={Mensaje} onChange={(e) => setMensaje(e.target.value)} required />
                            </FloatingLabel>
                            <p className='text-white'>Al enviar mis datos <Link target='black' to="/privacidad">Acepto la política de privacidad</Link> aplicada a mis datos.</p>
                            <Button className="contact-button" onClick={handleSubmit}>
                                Enviar
                            </Button>
                        </Form>
                        )}

                        {error && (
                            <Alert variant="danger" className="mt-3 text-start" dismissible onClose={() => setError('')}>{error}</Alert>
                        )}
                        
                        {loading && <Spinner animation="border" />}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Contacto;